export const adminAccounts = {
  "admin.accounts.pageTitle": "Account Management",
  "admin.accounts.pageDescription": "Manage and view all user accounts in the system",
  "admin.accounts.title": "Account Management", 
  "admin.accounts.subtitle": "View and manage all user accounts with comprehensive filtering and sorting options",
  "admin.accounts.errorTitle": "Error Loading Accounts",
  "admin.accounts.errorMessage": "Failed to load account data. Please try again.",
  "admin.accounts.retryButton": "Retry",

  // Filters section
  "admin.accounts.filters.title": "Account Filters",
  "admin.accounts.filters.accountInformationTitle": "Account Information",
  "admin.accounts.filters.dateRangeTitle": "Date Range",
  "admin.accounts.filters.balanceRangeTitle": "Balance Range",
  "admin.accounts.filters.accountNumber": "Account Number",
  "admin.accounts.filters.accountNumberPlaceholder": "Enter exact account number",
  "admin.accounts.filters.username": "Username", 
  "admin.accounts.filters.usernamePlaceholder": "Enter exact username",
  "admin.accounts.filters.accountStatus": "Account Status",
  "admin.accounts.filters.accountStatusPlaceholder": "Select account status",
  "admin.accounts.filters.allStatuses": "All Statuses",
  "admin.accounts.filters.dateFrom": "Account Opened From (yyyy-mm-dd)",
  "admin.accounts.filters.dateTo": "Account Opened To (yyyy-mm-dd)",
  "admin.accounts.filters.accountShareType": "Account Share Type",
  "admin.accounts.filters.accountShareTypePlaceholder": "Select share type",
  "admin.accounts.filters.allShareTypes": "All Share Types",
  "admin.accounts.filters.programPercent": "Program Percent",
  "admin.accounts.filters.programPercentPlaceholder": "Select program percent",
  "admin.accounts.filters.allProgramPercents": "All Program Percents",
  "admin.accounts.filters.balanceMin": "Minimum Balance",
  "admin.accounts.filters.balanceMinPlaceholder": "Enter minimum balance",
  "admin.accounts.filters.balanceMax": "Maximum Balance", 
  "admin.accounts.filters.balanceMaxPlaceholder": "Enter maximum balance",
  "admin.accounts.filters.applyFilters": "Apply Filters",
  "admin.accounts.filters.clearFilters": "Clear Filters",

  // Table section
  "admin.accounts.table.title": "User Accounts",
  "admin.accounts.table.showing": "Showing",
  "admin.accounts.table.of": "of",
  "admin.accounts.table.accounts": "accounts",
  "admin.accounts.table.accountNumber": "Account Number",
  "admin.accounts.table.username": "Username",
  "admin.accounts.table.name": "Name",
  "admin.accounts.table.status": "Status",
  "admin.accounts.table.shareType": "Share Type",
  "admin.accounts.table.programPercent": "Program %",
  "admin.accounts.table.balance": "Balance", 
  "admin.accounts.table.creationDate": "Creation Date",
  "admin.accounts.table.lastUpdate": "Last Update",
  "admin.accounts.table.errorMessage": "Failed to load accounts data",
  "admin.accounts.table.noDataMessage": "No accounts found matching the current filters",

  // Status translations
  "admin.accounts.table.status.active": "Active",
  "admin.accounts.table.status.inactive": "Inactive",

  // Profits page translations
  "admin.accounts.profits.pageTitle": "Accounts Profits Management",
  "admin.accounts.profits.pageDescription": "View and analyze account profit history with comprehensive filtering options",
  "admin.accounts.profits.title": "Accounts Profits Management",
  "admin.accounts.profits.subtitle": "Comprehensive view of account profit history with advanced filtering and analysis",
  "admin.accounts.profits.errorTitle": "Error Loading Profits Data",
  "admin.accounts.profits.errorMessage": "Failed to load account profits data. Please try again.",
  "admin.accounts.profits.retryButton": "Retry",

  // Profits filters section
  "admin.accounts.profits.filters.title": "Profit Filters",
  "admin.accounts.profits.filters.accountInformationTitle": "Account Information",
  "admin.accounts.profits.filters.periodTitle": "Period",
  "admin.accounts.profits.filters.profitsTitle": "Profits",
  "admin.accounts.profits.filters.accountNumber": "Account Number",
  "admin.accounts.profits.filters.accountNumberPlaceholder": "Enter exact account number",
  "admin.accounts.profits.filters.username": "Username",
  "admin.accounts.profits.filters.usernamePlaceholder": "Enter exact username",
  "admin.accounts.profits.filters.accountShare": "Account Share",
  "admin.accounts.profits.filters.accountSharePlaceholder": "Select account share type",
  "admin.accounts.profits.filters.allAccountShares": "All Share Types",
  "admin.accounts.profits.filters.dateFrom": "Period From (yyyy-mm-dd)",
  "admin.accounts.profits.filters.dateTo": "Period To (yyyy-mm-dd)",
  "admin.accounts.profits.filters.userProfitRange": "User Profit Range",
  "admin.accounts.profits.filters.userProfitMin": "Minimum User Profit",
  "admin.accounts.profits.filters.userProfitMinPlaceholder": "Enter minimum user profit",
  "admin.accounts.profits.filters.userProfitMax": "Maximum User Profit",
  "admin.accounts.profits.filters.userProfitMaxPlaceholder": "Enter maximum user profit",
  "admin.accounts.profits.filters.tradingProfitRange": "Trading Profit Range",
  "admin.accounts.profits.filters.tradingProfitMin": "Minimum Trading Profit",
  "admin.accounts.profits.filters.tradingProfitMinPlaceholder": "Enter minimum trading profit",
  "admin.accounts.profits.filters.tradingProfitMax": "Maximum Trading Profit",
  "admin.accounts.profits.filters.tradingProfitMaxPlaceholder": "Enter maximum trading profit",
  "admin.accounts.profits.filters.programProfitRange": "Program Profit Range",
  "admin.accounts.profits.filters.programProfitMin": "Minimum Program Profit",
  "admin.accounts.profits.filters.programProfitMinPlaceholder": "Enter minimum program profit",
  "admin.accounts.profits.filters.programProfitMax": "Maximum Program Profit",
  "admin.accounts.profits.filters.programProfitMaxPlaceholder": "Enter maximum program profit",
  "admin.accounts.profits.filters.applyFilters": "Apply Filters",
  "admin.accounts.profits.filters.clearFilters": "Clear Filters",

  // Profits table section
  "admin.accounts.profits.table.title": "Account Profits Data",
  "admin.accounts.profits.table.showing": "Showing",
  "admin.accounts.profits.table.of": "of",
  "admin.accounts.profits.table.records": "records",
  "admin.accounts.profits.table.accountNumber": "Account Number",
  "admin.accounts.profits.table.username": "Username",
  "admin.accounts.profits.table.name": "Name",
  "admin.accounts.profits.table.shareType": "Share Type",
  "admin.accounts.profits.table.period": "Period",
  "admin.accounts.profits.table.userProfit": "User Profit",
  "admin.accounts.profits.table.tradingProfit": "Trading Profit",
  "admin.accounts.profits.table.programProfit": "Program Profit",
  "admin.accounts.profits.table.errorMessage": "Failed to load profits data",
  "admin.accounts.profits.table.noDataMessage": "No profit records found matching the current filters",

  // Profits Totals page translations
  "admin.accounts.profitsTotals.title": "Accounts Profits Totals Management",
  "admin.accounts.profitsTotals.subtitle": "View and analyze total account profits with comprehensive filtering options",
  "admin.accounts.profitsTotals.errorTitle": "Error Loading Profits Totals Data",
  "admin.accounts.profitsTotals.errorMessage": "Failed to load account profits totals data. Please try again.",
  "admin.accounts.profitsTotals.retryButton": "Retry",

  // Profits Totals filters section
  "admin.accounts.profitsTotals.filters.title": "Profit Totals Filters",
  "admin.accounts.profitsTotals.filters.accountInformationTitle": "Account Information",
  "admin.accounts.profitsTotals.filters.profitsTitle": "Profits",
  "admin.accounts.profitsTotals.filters.accountNumber": "Account Number",
  "admin.accounts.profitsTotals.filters.accountNumberPlaceholder": "Enter exact account number",
  "admin.accounts.profitsTotals.filters.username": "Username",
  "admin.accounts.profitsTotals.filters.usernamePlaceholder": "Enter exact username",
  "admin.accounts.profitsTotals.filters.accountShare": "Account Share",
  "admin.accounts.profitsTotals.filters.accountSharePlaceholder": "Select account share type",
  "admin.accounts.profitsTotals.filters.allAccountShares": "All Share Types",
  "admin.accounts.profitsTotals.filters.userProfitRange": "User Profit Range",
  "admin.accounts.profitsTotals.filters.userProfitMin": "Minimum User Profit",
  "admin.accounts.profitsTotals.filters.userProfitMinPlaceholder": "Enter minimum user profit",
  "admin.accounts.profitsTotals.filters.userProfitMax": "Maximum User Profit",
  "admin.accounts.profitsTotals.filters.userProfitMaxPlaceholder": "Enter maximum user profit",
  "admin.accounts.profitsTotals.filters.tradingProfitRange": "Trading Profit Range",
  "admin.accounts.profitsTotals.filters.tradingProfitMin": "Minimum Trading Profit",
  "admin.accounts.profitsTotals.filters.tradingProfitMinPlaceholder": "Enter minimum trading profit",
  "admin.accounts.profitsTotals.filters.tradingProfitMax": "Maximum Trading Profit",
  "admin.accounts.profitsTotals.filters.tradingProfitMaxPlaceholder": "Enter maximum trading profit",
  "admin.accounts.profitsTotals.filters.programProfitRange": "Program Profit Range",
  "admin.accounts.profitsTotals.filters.programProfitMin": "Minimum Program Profit",
  "admin.accounts.profitsTotals.filters.programProfitMinPlaceholder": "Enter minimum program profit",
  "admin.accounts.profitsTotals.filters.programProfitMax": "Maximum Program Profit",
  "admin.accounts.profitsTotals.filters.programProfitMaxPlaceholder": "Enter maximum program profit",
  "admin.accounts.profitsTotals.filters.applyFilters": "Apply Filters",
  "admin.accounts.profitsTotals.filters.clearFilters": "Clear Filters",

  // Profits Totals table section
  "admin.accounts.profitsTotals.table.title": "Account Profits Totals Data",
  "admin.accounts.profitsTotals.table.showing": "Showing",
  "admin.accounts.profitsTotals.table.of": "of",
  "admin.accounts.profitsTotals.table.records": "records",
  "admin.accounts.profitsTotals.table.accountNumber": "Account Number",
  "admin.accounts.profitsTotals.table.username": "Username",
  "admin.accounts.profitsTotals.table.name": "Name",
  "admin.accounts.profitsTotals.table.shareType": "Share Type",
  "admin.accounts.profitsTotals.table.userProfit": "User Profit",
  "admin.accounts.profitsTotals.table.tradingProfit": "Trading Profit",
  "admin.accounts.profitsTotals.table.programProfit": "Program Profit",
  "admin.accounts.profitsTotals.table.errorMessage": "Failed to load profits totals data",
  "admin.accounts.profitsTotals.table.noDataMessage": "No profit totals records found matching the current filters",

  // Profits Registration page translations
  "admin.accounts.profitsRegistration.title": "Register Trading Profits",
  "admin.accounts.profitsRegistration.subtitle": "Register monthly trading profits for all broker accounts in the system",
  "admin.accounts.profitsRegistration.registerSection.title": "Register Trading Profits",
  "admin.accounts.profitsRegistration.registerSection.monthLabel": "Month",
  "admin.accounts.profitsRegistration.registerSection.monthDescription": "Format of the month is \"yyyy-mm-01\", profits of previous month are registered the first day of current month.",
  "admin.accounts.profitsRegistration.registerSection.monthPlaceholder": "yyyy-mm-01",
  "admin.accounts.profitsRegistration.registerSection.registerButton": "Register Trading Profits",
  "admin.accounts.profitsRegistration.resultSection.title": "Result",
  "admin.accounts.profitsRegistration.resultSection.operationResult": "Operation Result",
  "admin.accounts.profitsRegistration.resultSection.success": "Success",
  "admin.accounts.profitsRegistration.resultSection.fail": "Fail",
  "admin.accounts.profitsRegistration.resultSection.numBrokerAccounts": "Num Broker accounts",
  "admin.accounts.profitsRegistration.resultSection.numRegisteredAccounts": "Num Registered accounts",
  "admin.accounts.profitsRegistration.resultSection.accountsNotRegistered": "Accounts not registered",
  "admin.accounts.profitsRegistration.resultSection.accountsAlreadyRegistered": "Accounts profits already registered",
  "admin.accounts.profitsRegistration.resultSection.totalProfit": "Total Profit",
  
  // Validation messages
  "admin.accounts.profitsRegistration.validation.invalidFormat": "Month must be in format yyyy-mm-01",
  "admin.accounts.profitsRegistration.validation.invalidDate": "Invalid date",
  "admin.accounts.profitsRegistration.validation.invalidMonth": "Month must be between 01 and 12",
  "admin.accounts.profitsRegistration.validation.futureMonth": "Cannot register profits for future months",

  // Toast messages
  "admin.accounts.profitsRegistration.messages.success": "Profits Registered Successfully",
  "admin.accounts.profitsRegistration.messages.successDescription": "Successfully registered account profits",
  "admin.accounts.profitsRegistration.messages.error": "Registration Error",
  "admin.accounts.profitsRegistration.messages.csrfError": "Failed to generate security token",
  "admin.accounts.profitsRegistration.messages.authError": "Authentication required",
  "admin.accounts.profitsRegistration.messages.serverError": "Server error occurred",
  "admin.accounts.profitsRegistration.messages.operationFailed": "Profit registration failed",
  "admin.accounts.profitsRegistration.messages.unexpectedError": "An unexpected error occurred",

  // Balance Update page translations
  "admin.accounts.balanceUpdate.title": "Update Account Balances",
  "admin.accounts.balanceUpdate.subtitle": "Update current balance for all trading accounts from broker system",
  "admin.accounts.balanceUpdate.updateSection.title": "Update Account Balances",
  "admin.accounts.balanceUpdate.updateSection.updateButton": "Update Account Balances",
  "admin.accounts.balanceUpdate.resultSection.title": "Result",
  "admin.accounts.balanceUpdate.resultSection.operationResult": "Operation Result",
  "admin.accounts.balanceUpdate.resultSection.success": "Success",
  "admin.accounts.balanceUpdate.resultSection.fail": "Fail",
  "admin.accounts.balanceUpdate.resultSection.numBrokerAccounts": "Num Broker accounts",
  "admin.accounts.balanceUpdate.resultSection.numUpdatedAccounts": "Num Updated accounts",
  "admin.accounts.balanceUpdate.resultSection.accountsNotRegistered": "Accounts not registered",
  "admin.accounts.balanceUpdate.resultSection.totalFunds": "Total Funds",

  // Balance Update toast messages
  "admin.accounts.balanceUpdate.messages.success": "Balances Updated Successfully",
  "admin.accounts.balanceUpdate.messages.successDescription": "Successfully updated account balances",
  "admin.accounts.balanceUpdate.messages.error": "Update Error",
  "admin.accounts.balanceUpdate.messages.csrfError": "Failed to generate security token",
  "admin.accounts.balanceUpdate.messages.authError": "Authentication required",
  "admin.accounts.balanceUpdate.messages.serverError": "Server error occurred",
  "admin.accounts.balanceUpdate.messages.operationFailed": "Balance update failed",
  "admin.accounts.balanceUpdate.messages.unexpectedError": "An unexpected error occurred",

  // Auto Account Registration page translations
  "admin.accounts.autoRegister.title": "Auto Account Registration",
  "admin.accounts.autoRegister.subtitle": "Automatically register user trading accounts from broker system",
  "admin.accounts.autoRegister.registerSection.title": "Auto Register Accounts",
  "admin.accounts.autoRegister.registerSection.registerButton": "Auto Register Accounts",
  "admin.accounts.autoRegister.resultSection.title": "Result",
  "admin.accounts.autoRegister.resultSection.operationResult": "Operation Result",
  "admin.accounts.autoRegister.resultSection.success": "Success",
  "admin.accounts.autoRegister.resultSection.fail": "Fail",
  "admin.accounts.autoRegister.resultSection.matchedUsers": "Matched Accounts",
  "admin.accounts.autoRegister.resultSection.unmatchedUsers": "UnMatched Accounts",
  "admin.accounts.autoRegister.resultSection.usersWithoutAccounts": "Users Without Accounts",
  "admin.accounts.autoRegister.resultSection.ignoredOfferName": "Ignored Offer Name",
  "admin.accounts.autoRegister.resultSection.ignoredIds": "Ignored IDs",
  "admin.accounts.autoRegister.messages.success": "Auto Registration Completed Successfully",
  "admin.accounts.autoRegister.messages.successDescription": "Successfully registered accounts",
  "admin.accounts.autoRegister.messages.error": "Auto Registration Error",
  "admin.accounts.autoRegister.messages.csrfError": "Failed to generate security token",
  "admin.accounts.autoRegister.messages.authError": "Authentication required",
  "admin.accounts.autoRegister.messages.serverError": "Server error occurred",
  "admin.accounts.autoRegister.messages.operationFailed": "Auto registration failed",
  "admin.accounts.autoRegister.messages.unexpectedError": "An unexpected error occurred",
};